import { getEmptyDataMaps } from '../utils'

export const ErrorMessage = 'ErrorOccurred'
export const RemoteRefDeadComp = 'RemoteRefDeadComp'
export const REMOTE_REF_DEAD_COMP = {
	structure: {
		RemoteRefDeadComp: {
			componentType: RemoteRefDeadComp,
			id: RemoteRefDeadComp,
			layout: {},
		},
	},
	originalStructure: {
		RemoteRefDeadComp: {
			componentType: RemoteRefDeadComp,
			id: RemoteRefDeadComp,
			layout: {},
		},
	},
	data: getEmptyDataMaps(),
	translations: {},
	rootId: RemoteRefDeadComp,
}
